const AdminTrip = {
  /**
   *Account
   */

  addTrip: {
    url: "/newTrip",
    method: "POST",
  },
  tripList: {
    url: "/trips",
    method: "GET",
  },
  updateTrip: (id) => ({
    url: `/updateTrip/${id}`,
    method: "PUT",
  }),
  tripDetail: (id) => ({
    url: `/trip/${id}`,
    method: "GET",
  }),
  updateTripStatus: (id) => ({
    url: `/trip-status/${id}`,
    method: "PUT",
  }),
  deleteTrip: (id) => ({
    url: `/deleteTrip/${id}`,
    method: "DELETE",
  }),
  addTripReview: {
    url: "/tripReview",
    method: "POST",
  },
  tripReviewList: {
    url: "/tripReviews",
    method: "GET",
  },

  publicTripReviewList: {
    url: "/public/tripReviews",
    method: "GET",
  },
  getTripReview: (id) => ({
    url: `/tripReview/${id}`,
    method: "GET",
  }),
  deleteTripReview: (id) => ({
    url: `/tripReview/${id}`,
    method: "DELETE",
  }),
  // signup: {
  //     url: "/registerVendor",
  //     method: "POST",
  // },
  // verifyOTP: (id) => ({
  //     url: `verify_otp/${id}`,
  //     method: "POST",
  // })
};
export default AdminTrip;
